<template>
  <div id="home" v-loading="loading">
    <carousel
      :perPage="1"
      paginationActiveColor="#FFFFFF"
      paginationColor="rgba(255, 255, 255, 0.4)"
      :autoplay="true"
      :autoplayTimeout="5000"
      :loop="true"
    >
      <slide
        v-for="(carousel, index) in imageBanner"
        :key="index"
        id="VueCarousel-slide-0"
      >
        <div
          class="bg-slide"
          :style="`background-image:url(` + usrlSystem + carousel.file + `);`"
        >
          <div class="bg-slide-secondary">
            <div class="flex-display js-between ai-center header-home">
              <el-image
                :src="require(`@/assets/logo-white.png`)"
                class="text-left"
              ></el-image>
              <div class="flex-display ai-center">
                <el-form @submit.prevent.native @keyup.enter.native="search">
                  <el-input
                    placeholder="ค้นหาหลักสูตร"
                    prefix-icon="el-icon-search"
                    class="search-input"
                    @blur="
                      (showInputSearch = false),
                        !searchText && showSearch ? search() : null
                    "
                    @keyup.enter.native="search"
                    :class="{ show: showInputSearch }"
                    clearable
                    ref="search"
                    v-model="searchText"
                  ></el-input>

                  <el-button
                    class="primary font-weight-icon"
                    v-if="!showInputSearch"
                    @click="openSearchInput(index)"
                    circle
                  >
                    <i class="el-icon-search"></i
                  ></el-button>
                </el-form>
                <el-dropdown
                  v-if="
                    user &&
                      (user.role == 0 || user.role == 60 || user.role == 80)
                  "
                  trigger="click"
                  class="cursor-pointer mg-l-4"
                >
                  <div class="noti-icon-box">
                    <el-badge
                      is-dot
                      class="item noti"
                      :hidden="notReadNoti == 0"
                    >
                      <i class="fas fa-bell text-font-30 color-white"></i>
                    </el-badge>
                  </div>
                  <el-dropdown-menu slot="dropdown" class="menu-noti-box">
                    <div class="pd-x-3 pd-y-5">
                      <div class="flex-display js-between ai-center pd-b-4">
                        <h5 class="mg-y-less">
                          {{ `แจ้งเตือน (${notReadNoti}/${totalNoti})` }}
                        </h5>
                        <i class="fas fa-bell color-warning "></i>
                      </div>
                      <div
                        v-for="item in notiList"
                        :key="item._id"
                        class="border-b pd-b-4 pd-t-4 cursor-pointer"
                        :title="
                          !item.courseId && item.type == 1
                            ? `หลักสูตรนี้ไม่มีในระบบ`
                            : !item.userId && item.type == 2
                            ? 'นักเรียนคนนี้ไม่มีในระบบ'
                            : null
                        "
                        :class="
                          (!item.courseId && item.type == 1) ||
                          (!item.userId && item.type == 2)
                            ? 'cursor-not-allowed'
                            : 'cursor-pointer'
                        "
                      >
                        <div v-if="item.type == 1">
                          <div
                            @click="
                              item.courseId
                                ? readNotification(item._id, item.courseId)
                                : null
                            "
                            class="flex-display js-between ai-center pd-b-5"
                          >
                            <div
                              :class="
                                item.courseId
                                  ? 'cursor-pointer'
                                  : 'cursor-not-allowed'
                              "
                              class="box-image square"
                            >
                              <avatar
                                :rounded="false"
                                :username="item.name"
                                :src="
                                  `${gerUrlImageCourse(
                                    item.courseId,
                                    item.illustration.file
                                  )}`
                                "
                                :size="30"
                              ></avatar>
                            </div>
                            <a
                              :class="
                                item.courseId
                                  ? 'cursor-pointer'
                                  : 'cursor-not-allowed'
                              "
                              class="color-secondary text-font-10"
                              >{{ `${item.verbs} ${item.time}` }}</a
                            >
                          </div>
                          <p class="text-font-10 mg-y-less">
                            {{ item.name }}
                          </p>
                        </div>
                        <div
                          v-if="item.type == 2"
                          @click="
                            item.userId
                              ? readNotification(item._id, item.userId)
                              : null
                          "
                          class="flex-display ai-start pd-b-5"
                        >
                          <div
                            :class="
                              item.userId
                                ? 'cursor-pointer'
                                : 'cursor-not-allowed'
                            "
                            class="box-image "
                          >
                            <avatar
                              :class="{
                                facebook:
                                  item.userFrom == 'faceBook' &&
                                  item.profileImg == '',
                              }"
                              :rounded="false"
                              :username="`${item.nameTH}`"
                              :src="
                                item.profileImg
                                  ? `${urlImage}${item.userId}/${item.profileImg}`
                                  : item.userFrom == 'faceBook' &&
                                    item.profileImg == ''
                                  ? `https://graph.facebook.com/${item.profileFrom}/picture?type=small`
                                  : `${item.profileFrom}`
                              "
                              :size="30"
                            ></avatar>
                          </div>
                          <div class=" width-100 noflex">
                            <div class="text-left text-font-10 pd-l-4">
                              <p class="mg-y-less">
                                {{ `${item.nameTH} ${item.surnameTH}` }}
                                <span class="color-warning">{{
                                  item.verbs
                                }}</span>
                              </p>
                              <p class="mg-y-less">หลักสูตร {{ item.name }}</p>
                              <a
                                :class="
                                  item.userId
                                    ? 'cursor-pointer'
                                    : 'cursor-not-allowed'
                                "
                                class="color-gray"
                                >{{ item.createdAt | dateTimeTh }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-center pd-t-4">
                        <a
                          @click="$router.push('/notification')"
                          class="color-secondary text-font-12"
                          >ดูแจ้งเตือนทั้งหมด</a
                        >
                      </div>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
                <div v-if="user" class="mg-l-4"></div>
                <PopupUser v-if="user" :imageSize="40" />
                <div
                  v-if="typeof token == 'undefined' || token == ''"
                  class="pd-l-4"
                >
                  <el-button
                    @click="$router.push('/signin')"
                    round
                    class="primary text-weight-600 text-font-16 "
                    >เข้าสู่ระบบ</el-button
                  >
                </div>
              </div>
            </div>
            <!-- <img
              src="@/assets/QR-Code.png"
              class="qrcode-slide mg-t-1 position-absolute"
            /> -->
            <div v-if="!user" class="text-left pd-x-1 box-des">
              <h3 class="color-white text-index text-font-24">
                e-Learning by AvocadoX
              </h3>
              <el-button
                @click="$router.push('/signup')"
                round
                class="primary text-font-20 text-weight-600"
                >ลงทะเบียนเรียนออนไลน์</el-button
              >
            </div>
          </div>
        </div>
      </slide>
    </carousel>
    <el-row class="pd-x-1 pd-y-2">
      <el-col
        v-for="item in courseList"
        :key="item._id"
        :span="24"
        :sm="12"
        :md="8"
        class="pd-4 position-relative"
      >
        <CourseCard
          :id="item._id"
          :image="
            typeof item.illustration != 'undefined'
              ? item.illustration.file
              : ''
          "
          :name="item.name"
          :statusCourse="item.statusCourse"
          :class="{ 'cursor-not-allowed': item.statusCourse == 0 }"
        />
        <el-button
          v-if="item.statusCourse == 0"
          type="primary"
          class="coming-button cursor-not-allowed"
          round
          >หลักสูตรจะเปิดเร็ว ๆ นี้</el-button
        >
      </el-col>
    </el-row>
    <div v-if="totalCourse > pageSize" class="pd-y-3">
      <el-pagination
        v-if="totalCourse > pageSize"
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalCourse"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
    <Cookie />
    <Footer id="footer" />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import CourseCard from "@/components/course/CourseCard";
import Cookie from "@/components/template/Cookie";
import Footer from "@/components/template/Footer";
import { HTTP } from "@/service/axios.js";
import PopupUser from "@/components/template/PopupUser";
import Avatar from "vue-avatar";

export default {
  components: {
    Carousel,
    Slide,
    CourseCard,
    Cookie,
    Footer,
    PopupUser,
    Avatar,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      searchText: "",
      showInputSearch: false,
      courseList: [],
      imageBanner: [],
      usrlSystem: process.env.VUE_APP_BASE_URL_SYSTEM,
      loading: true,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      totalNoti: 0,
      notReadNoti: 0,
      notiList: [],
      totalCourse: 0,
      pageSize: 18,
      page: 1,
      showSearch: false,
    };
  },
  mounted() {
    this.fetchGeneral();
    this.fetchCourse();
    if (this.token) {
      this.fetchNotification();
    }

    this.fetchCourseList();
  },
  methods: {
    gerUrlImageCourse(id, image) {
      if (this.image != "") {
        return `${this.urlCouse}${id}/${image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    fetchNotification() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`noti`).then((res) => {
        if (res.data.success) {
          this.totalNoti = res.data.obj.length;
          let notRead = res.data.obj.filter((filter) => filter.read === false);
          this.notReadNoti = notRead.length;
          this.notiList = res.data.obj.slice(0, 4);
        }
      })
      .catch((e) => {
        this.$store.commit("SIGNOUT");
        this.$router.push({ path: "/" }).catch(() => {
          window.location.reload();
        })
      });
    },
    readNotification(id, goto) {
      if (this.user.role == 60 || this.user.role == 80) {
        this.$router.push(`/name/list/course?userId=${goto}`).catch((e) => {});
      } else {
        this.$router.push(`/course/detail?courseId=${goto}`).catch((e) => {});
      }

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`read/${id}`).then((res) => {});
    },
    fetchGeneral() {
      HTTP.get(`get/general`)
        .then((res) => {
          if (res.data.success && res.data.obj) {
            this.imageBanner = res.data.obj.images;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.setStyleCarousel();
          }, 500);
        });
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    setStyleCarousel() {
      if (document.getElementById("VueCarousel-slide-0")) {
        document.getElementById("VueCarousel-slide-0").style.transition =
          "all 0s";
        document
          .getElementById("VueCarousel-slide-0")
          .classList.add("VueCarousel-slide-active");
      }
      setTimeout(() => {
        if (document.getElementById("VueCarousel-slide-0")) {
          document.getElementById("VueCarousel-slide-0").style.transition =
            "all 1.5s";
        }
      }, 1500);
    },
    openSearchInput(index) {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search[index].focus();
      }, 500);
    },
    search() {
      this.$router.push(`/search/?query=${this.searchText}`);
    },
    changePage(page) {
      this.loading = true;
      this.page = page;
      this.fetchCourse(page);
    },
    fetchCourse() {
      HTTP.get(
        `list/course/${(this.page - 1) * this.pageSize}/${this.pageSize}/all`
      )
        .then((res) => { 
          if (res.data.success) {
            this.courseList = res.data.obj;
            this.totalCourse = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.header-home {
  padding: 40px 60px 40px 60px;
}
.text-font-20 {
  font-size: 20px !important;
}

.font-weight-icon .el-icon-search {
  font-weight: 600 !important;
}
.bg-slide {
  background-color: $--color-bg-slide;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100%;
  height: 540px;
  position: relative;
}
.bg-slide-secondary {
  /* background: linear-gradient(
    86.01deg,
    rgba(0, 101, 179, 0.9) 16.88%,
    rgba(0, 101, 179, 0.7) 37.85%,
    rgba(0, 101, 179, 0.1) 61.62%
  ); */
  width: 100%;
  height: 100%;
}
.box-des {
  padding-top: 95px;
  line-height: 2.5em;
}
@media (max-width: 1199.98px) {
}
@media (max-width: 991.98px) {
  /* .box-des {
    padding-top: 100px;
  } */
}
@media (max-width: 767.98px) {
}
@media (max-width: 575.98px) {
  .header-home {
    padding: 40px 20px 40px 20px;
  }
}
</style>
